/**
 * @file Logo lockup: optional mark from /public + “Storyline” (black) + “Help” (red).
 * Icon file: `public/storyline-help-icon.png` (served as `/storyline-help-icon.png`).
 */
import { Box, Typography, type TypographyProps } from "@mui/material";

export interface StorylineHelpBrandProps {
  /** Typography variant for the wordmark. */
  variant?: TypographyProps["variant"];
  /** Icon width/height in px. */
  iconSize?: number;
}

export function StorylineHelpBrand({ variant = "h6", iconSize = 30 }: StorylineHelpBrandProps) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
      <Box
        component="img"
        src="/storyline-help-icon.png"
        alt=""
        width={iconSize}
        height={iconSize}
        sx={{ flexShrink: 0, display: "block", objectFit: "contain" }}
      />
      <Typography variant={variant} fontWeight={700} component="span" sx={{ lineHeight: 1.2 }}>
        <Box component="span" sx={{ color: "common.black" }}>
          Storyline
        </Box>
        <Box component="span" sx={{ color: "#c62828" }}>
          {" "}
          Help
        </Box>
      </Typography>
    </Box>
  );
}
